import { IOrgRole } from './../../../models/IOrgRole';
import { RoleService } from './../../../services/role.service';
import { IEntity } from './../../../models/IEntity';
import { OrgService } from './../../../services/org.service';
import { IRole } from './../../../models/IRole';
import { Component, OnInit } from '@angular/core';
import { IOrg } from 'app/models/IOrg';
import { IUser } from 'app/models/IUser';
import { AdminService } from 'app/services/admin.service';
import { UserService} from 'app/services/user.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-list-user',
  templateUrl: './list-user.component.html',
  styleUrls: ['./list-user.component.scss']
})
export class ListUserComponent implements OnInit {

  public org: IOrg;
  //public roleSub: Subscription;
  public emailUsers: IUser[] = [];
  public role: IRole;
  public data: IUser[] = [];
  public data2: IUser[];
  public orgRole: IOrgRole = { orgId: '', roleId: '' };
  public filterQuery = '';
  constructor(private adminService: AdminService,
              private orgService: OrgService,
              private roleService: RoleService,
              private userService: UserService) { }

  ngOnInit() {
    this.data.length = 0;
    this.orgService.getOrg().subscribe(org => {
      this.org = org;
      this.roleService.getRole().subscribe(role => {
        this.role = role;
        this.adminService.getUsersByOrg(<IEntity> org).subscribe(
          result => {
            this.data = result;
          })
      })

    })
      //this.role = this.roleService.getRole();

  }

  ngOnDestroy() {
    //this.roleSub.unsubscribe();
    //this.adminService.getOrgs()

  }

  toggleSelected(user: IUser) {
    if (user.isSelected)
      user.isSelected = false;
    else
      user.isSelected = true;
    
  }

  toggleAll(checked: boolean) {
    this.data.map((user) => {
      user.isSelected = false;

    });
    this.emailUsers.length = 0;
    this.data.map((user) => {
      user.isSelected = checked;

    });
    this.data.forEach(user => {
      if (user.isSelected) {
      this.emailUsers.push(user);
      }
    })
  }



  // setUser(user: IUser) {
  //   this.userService.changeUser(user);
  //   }
}




// WEBPACK FOOTER //
// /Users/vincenzodavi/source/quickpickpool_aspnetcore3/quickpickpool_aspnetcore3/client/src/app/admin/user/list-user/list-user.component.ts